export default "__VITE_ASSET__DTw5WcDy__"